export default function componentStyleOverrides(theme) {
  return {
    MuiCssBaseline: {},
    MuiBox: {
      styleOverrides: {
        root: {
          color: theme.darkTextPrimary,
          fontSize: "1rem",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          boxShadow: "none",
          padding: ".7em 1.4em",
          // letterSpacing: "1.71px",
          borderRadius: "4px",
          "&.Mui-disabled": {
            backgroundColor: "#00000033",
            color: "#fff",
            fontWeight: "bold",
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          "&.Mui-checked": {
            color: theme.darkPrimary,
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          "&.Mui-checked, &.Mui-selected svg": {
            color: theme.darkPrimary,
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: theme.middleGray,
          marginBottom: "4px",
          fontSize: "1rem",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          "& .MuiCheckbox-root, & .MuiRadio-root": {
            padding: "4px 9px",
          },
        },
        label: {
          fontSize: "1rem",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          "&.Mui-selected, &.Mui-selected svg": {
            color: theme.darkPrimary,
          },
          "& .MuiTab-iconWrapper": {
            marginBottom: "16px",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          color: theme.lightBackgroundText,
          backgroundColor: theme.lightPrimary,
          boxShadow: "none",
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: { "&:last-child": { paddingBottom: 0 } },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: { fontSize: "12px", marginLeft: 0 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
            borderRadius: "0",
            borderBottom: `1px solid #000`,
            borderWidth: "0.5px",
          },
          "& ::placeholder": {
            color: "#C7C7C7",
            fontFamily: "BulgariTypeLight",
          },
        },
        input: { padding: "2px 0" },
      },
    },
  };
}
